import {
  type DeviceViewLabelsTab,
  isLabelsEntity,
} from 'components/DeviceView/deviceViewTypes';
import {
  getDeviceViewLabelsEntityId,
  getLabelsTargetsKey,
} from 'components/DeviceView/helpers/getDeviceViewLabelsEntityId';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface ShowLabelsDetailCommand {
  labelsTabs: DeviceViewLabelsTab[];
  selectedTabId: string;
  title: string;
}

export const showLabelsDetail: DeviceViewCommandFactory<
  ShowLabelsDetailCommand
> = (cmdContext) => (command) => {
  const generatedEntityId = getDeviceViewLabelsEntityId(command.labelsTabs);
  const firstTab = command.labelsTabs[0];
  if (generatedEntityId === null || firstTab === undefined) {
    return;
  }

  const selectedTab =
    command.labelsTabs.find((tab) => tab.columnKey === command.selectedTabId) ??
    firstTab;
  const title = command.title || selectedTab.title || 'Labels';
  const targetKey = getLabelsTargetsKey(command.labelsTabs);
  const labelsEntities = cmdContext
    .getState()
    .deviceViewEntities.filter(isLabelsEntity);
  const reusableEntity =
    labelsEntities.find(
      (entity) => getLabelsTargetsKey(entity.labelsTabs) === targetKey,
    ) ??
    labelsEntities.find((entity) =>
      entity.labelsTabs.some(
        (tab) => tab.id === selectedTab.id && tab.type === selectedTab.type,
      ),
    );
  const entityId = reusableEntity?.id ?? generatedEntityId;

  cmdContext.updateState((draft) => {
    const existingEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === entityId,
    );

    if (!draft.deviceViewWindows.some((win) => win.id === entityId)) {
      draft.deviceViewOpen = true;
      draft.activeDeviceViewEntityId = entityId;
      cmdContext.getState().handlersContainer.handleActiveDeviceEntityChange?.({
        deviceViewElement: 'labels',
        deviceViewEntityId: entityId,
      });
    }

    if (existingEntity === undefined) {
      draft.deviceViewEntities.unshift({
        deviceViewElement: 'labels',
        id: entityId,
        labelsTabs: command.labelsTabs,
        table: selectedTab.columnKey,
        tableFilters: {},
        tableSort: {},
        title,
      });
      return;
    }

    if (existingEntity.deviceViewElement === 'labels') {
      existingEntity.labelsTabs = command.labelsTabs;
      existingEntity.table = selectedTab.columnKey;
      existingEntity.title = title;
    }
  });
};
